import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SettingsProvider } from "@/lib/SettingsContext";

import SiteLayout from "@/layouts/SiteLayout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import MediaPage from "@/pages/MediaPage";
import BookConsultationPage from "@/pages/BookConsultationPage";
import BookSpeakingPage from "@/pages/BookSpeakingPage";
import SubmitInquiryPage from "@/pages/SubmitInquiryPage";
import PrivacyPage from "@/pages/PrivacyPage";

import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminInboxPage from "@/pages/admin/AdminInboxPage";
import AdminSettingsPage from "@/pages/admin/AdminSettingsPage";

function App() {
  return (
    <SettingsProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/media" element={<MediaPage />} />
            <Route path="/book-consultation" element={<BookConsultationPage />} />
            <Route path="/book-speaking" element={<BookSpeakingPage />} />
            <Route path="/inquiry" element={<SubmitInquiryPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            {/* Legacy redirects */}
            <Route
              path="/request-consultation"
              element={<Navigate to="/book-consultation" replace />}
            />
            <Route path="/speaking" element={<Navigate to="/book-speaking" replace />} />
            <Route path="/impact" element={<Navigate to="/media" replace />} />
          </Route>
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/inbox" element={<AdminInboxPage />} />
          <Route
            path="/admin/inquiries"
            element={<Navigate to="/admin/inbox" replace />}
          />
          <Route path="/admin/settings" element={<AdminSettingsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-center" />
      </BrowserRouter>
    </SettingsProvider>
  );
}

export default App;
